<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{form.main.is_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" v-if="form.main.is_station" slot="is_station">
            <label class="weui-form-preview__label">{{customLabel.is_station || "工位"}}</label>
            <em class="weui-form-preview__value">{{form.main.is_station}}</em>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.is_frequency" slot="is_frequency">
            <label class="weui-form-preview__label">{{customLabel.is_frequency || "检查频次"}}</label>
            <span class="weui-form-preview__value">{{form.main.is_frequency}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.is_qty" slot="is_qty">
            <label class="weui-form-preview__label">{{customLabel.is_qty || "抽样数量"}}</label>
            <span class="weui-form-preview__value">{{form.main.is_qty}}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.isd_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          
          <div class="weui-form-preview__item" v-if="item.isd_item" slot="isd_item"> 
            <label class="weui-form-preview__label">{{customLabel.isd_item || "检查项目"}}</label>
            <span class="weui-form-preview__value">{{item.isd_item}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.isd_method" slot="isd_method">
            <label class="weui-form-preview__label">{{customLabel.isd_method || "检查方法"}}</label>
            <span class="weui-form-preview__value">{{item.isd_method}}</span>
          </div>
          <div class="weui-form-preview__item" slot="isd_standard">
            <label class="weui-form-preview__label">{{customLabel.isd_standard || "检查标准"}}</label>
            <span class="weui-form-preview__value">{{item.isd_standard}}</span>
          </div>
          <div class="weui-form-preview__item" slot="isd_attach" v-if="item.isd_attach">
            <label class="weui-form-preview__label">示范图片</label>
            <file-list :value="item.isd_attach" />
          </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.creatorName">
            <label class="weui-form-preview__label">{{customLabel.creatorName || "录入人"}}</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.createTime">
            <label class="weui-form-preview__label">{{customLabel.createTime || "录入日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.createTime}}</span>
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import FileList from "@/components/FileList.vue";
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
   components: {
    FileList,
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/ipqcset",
      caller:'IpqcSet',
      xtype:'stock-ipqcset-formpanel'
    };
  }
};
</script>